import { toast, ToastOptions } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Função para obter as opções globais dos toasts
const getToastGlobalOptions = (): ToastOptions => {
  const themeFromLocalStorage = localStorage.getItem('theme');
  
  const toastGlobalOptions: ToastOptions = {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  };
  
  if (themeFromLocalStorage === 'dark') {
    toastGlobalOptions.theme = 'dark';
  }

  return toastGlobalOptions;
};

// Função genérica para exibir um toast
const showToast = (message: string, options: ToastOptions) => {
  toast(message, {
    ...getToastGlobalOptions(),
    ...options,
  });
};


// Função para exibir um toast de sucesso
export const showToastSuccess = (message: string) => {
  showToast(message, { type: toast.TYPE.SUCCESS });
};

// Função para exibir um toast de aviso
export const showToastWarning = (message: string) => {
  showToast(message, { type: toast.TYPE.WARNING });
};

// Função para exibir um toast de erro
export const showToastError = (message: string) => {
  showToast(message, { type: toast.TYPE.ERROR });
};

// Função para exibir um toast de informação
export const showToastInfo = (message: string) => {
  showToast(message, { type: toast.TYPE.INFO });
};